const intHnmConfig = {
  name: 'int',
  edsLoginLandingPage:
    'https://platform.int.heinemann.com/ui/login/landing-page',
  contentShareAppUrl: 'https://platform-content-share.int.heinemann.com/',
  contentProvider: 'https://platform.int.heinemann.com/ui/#/contentProvider/',
  learnosityAssessementPreview:
    'https://platform.int.heinemann.com/ui/#/assessment-view/preview',
  edsLogoutUrl: 'https://app01.int.tsg.hmhco.com/edcore/eds-login/logout',
  rootUrl: 'https://platform.int.heinemann.com',
  loginUrl: 'https://platform.int.heinemann.com/ui/login/',
  loggedInUrl: 'https://platform.int.heinemann.com/ui/logged-in/',
  loggedOutUrl: 'https://platform.int.heinemann.com/ui/login/logged-out/',
  helpUrl: 'http://downloads.hmlt.hmco.com/Help/Flight/LogIn/',
  privacyPolicyUrl:
    'https://www.heinemann.com/privacy/?utm_medium=shorturl&utm_source=privacy',
  termsAndConditionsUrl:
    'https://www.heinemann.com/platforms-terms-of-use/?utm_medium=shorturl&utm_source=platform-terms',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  edsPostLogoutRedirectUrl: 'https://platform.int.heinemann.com/',
  flightRosteredLoginUrl: 'https://platform.int.heinemann.com/ui/login/',
  edsLoginClientId: '2cc7842e-ed1b-401e-b203-c2756a26d795',
  edsLoginUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/initializeUri',
  edsLoginIssuer: 'https://platform-int.authorization.heinemann.com',
  edsGraphUrl:
    'https://app01.int.tsg.hmhco.com/edcore/hmheng-eds-api-gateway/graphql',
  edsLtiUrl: 'https://app01.int.tsg.hmhco.com/edcore/eds-lti/lti',
  edLtiUrl: 'https://api.int.br.internal/lti-platform',
  rceProtocolHost: 'http://int.hmhone.app.hmhco.com',
  planktonBaseUrl: 'https://d16qzots3do3wk.cloudfront.net/',
  isPlanktonPreview: true,
  edsContentShareClientId: '686d53aa-db86-4754-b265-bf2f36a527fb',
  edsContentShareInitializeUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-lti/lti/launch/share-link',
  edsContentShareAuthorizeUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-lti/lti/authorize',
  edsContentShareTokenUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-lti/lti/token',
  licensesRemoteEntrypoint: 'http://localhost:9999',
  restUdsApi: 'https://api.int.eng.hmhco.com/uds/',
  featureFlagURL:
    'https://platform.int.heinemann.com/featureFlagsCohorts.flight.json',
  doTheMathBaseUrl: 'https://platform.int.heinemann.com/ui/login',
  heinemannBaseURL: 'https://platform.int.heinemann.com',
  requestSigninDetails: '/ui/login/request-signin-details/',
  liftRoot: 'https://platform.int.heinemann.com/ui/',
  jasperReporting: 'https://int.hmhone.app.hmhco.com/jasperserver-pro',
  ampLoggedInURL: 'http://int.hmhone.app.hmhco.com/ui/logged-in/',
  ampSignedInURL: 'https://platform.int.heinemann.com/ui/signed-in/',
  edsInitUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/initializeUri',
  wormhole: 'https://api.int.br.internal/wh-api/graphql',
  wormholek8s: 'https://app01.int.tsg.hmhco.com/wormhole-api/graphql',
  apiBaseURL: 'http://int.hmhone.app.hmhco.com',
  restStagingProcessor: 'https://api.int.br.internal/idm-staging-processor',
  flightLogin: `https://platform.int.heinemann.com/ui/login/`,
  EDSLoginUrl: 'https://app01.int.tsg.hmhco.com/edcore/eds-login',
  edsAuthorizationCode:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  authorizationApi: 'http://int.hmhone.app.hmhco.com/api/authorization',
  restIdsGridApi: 'https://api.int.br.internal/ids-grid-api',
  hcpIdentityApiGateway:
    'https://app01.int.tsg.hmhco.com/hcp-identity-api-gateway',
  susAuth: 'http://int.hmhone.app.hmhco.com/api/authorization',
  ampLogin: 'https://platform.int.heinemann.com/ui/login',
  ltiCache: 'https://api.int.eng.hmhco.com/lti-deep-linking/cache',
  assessmentsK8: 'https://app01.int.tsg.hmhco.com/assessment',
};

module.exports = intHnmConfig;
